/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useRef, useState } from "react";
import DefaultBook from "../Images/defaultBook.png";
import KalpataruServices from "../Services/Kalpataru";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "../Styles/BookDetail.css";
import Slider from "react-slick";
import { useTranslation } from "react-i18next";
import i18n from "../i18n";
import Favfill from "../assets/img/favadd.svg";
import Favempty from "../assets/img/fav.svg";
import { BookContentType } from "./Epub";
import { userId } from "../Contexts/LocaleContext";
import { LogInModel } from "./LoginModel";
import leftArrow from "../assets/img/leftArrow1.png";
import rightArrow from "../assets/img/rightArrow1.png"
import closeicon from "../Images/close-round-border.svg"
import EpubServices from "../Services/Epub";
import { Breadcrumbs } from "./E-BooksComponent";
import bookmarkIcon from "../Images/Bookmark.svg"
import Loader from "./Loader";
import BookCoverPopup from "../Components/BookCoverPopup";
import { getMonthNameFromNumber } from "../Components/MonthUtils";
import { listToTree } from "../utils/tocUtils";
import KalyankalpataruSeo from "../Components/KalyankalpataruSeo";

const PrevArrow = ({ className, style, onClick }: any) => (
  <div className={className} style={style} onClick={onClick}>
    <img src={leftArrow} alt="Previous" height="40px" />
  </div>
);

const NextArrow = ({ className, style, onClick }: any) => (
  <div className={className} style={style} onClick={onClick}>
    <img src={rightArrow} alt="Next" height="40px" />
  </div>
);

const KalpataruDetailPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [kalpatrauDetail, setKalpatrauDetail] = useState<any>(undefined);
  const [refresh, setRefresh] = useState(false);
  const [kalpatruId, setKalpatruId] = useState("");
  const [relateds, setRelatedKalpatrau] = useState<any[] | undefined>(undefined);

  const location = useLocation();
  const [isLiked, setIsLiked] = useState<boolean>(false);
  const [showCoverPopup, setShowCoverPopup] = useState(false);
  const state = location.state as {
    kalpatruId: string,
    kalpatruSlug: string,
    bookName: string,
  };

  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />
  };

  const [logIn, setLogIn] = useState<boolean>(false);
  const [loading, setLoading] = useState(true);

  const closeModal = () => {
    setLogIn(false);
  };

  const UserIdentity = localStorage.getItem("UserId") as any;

  const [toggleFav, setToggleFav] = useState<boolean>(false);

  const [bookMark, setBookMark] = useState<boolean>(false)
  const [bookMarkData, setBookMarkData] = useState<any[] | undefined | any>(undefined);
  const [description, setDescription] = useState({ __html: "" });
  const [activeTab, setActiveTab] = useState<'related' | 'toc'>('related');
  const [expandedNodes, setExpandedNodes] = useState<Set<string>>(new Set());
  const [lastPos, setLastPos] = useState<any>(null);
  const [lastFontSize, setLastFontSize] = useState<number>(100);
  const [toc, setToc] = useState<any[]>([]);
  const [progress, setProgress] = useState<number>(0);
  const [navOrder, setNavOrder] = useState<number>(0);

  const navigationTree = useMemo(() => listToTree(toc), [toc]);
  const flatToc = useMemo(() => toc, [toc]);

  const notificationRef = useRef<any>(null);

  const showNotification = (message: any) => {
    notificationRef.current.innerText = message;
    notificationRef.current.style.display = 'block';

    setTimeout(() => {
      notificationRef.current.style.display = 'none';
    }, 3000);
  };

  const [loginState, setLoginState] = useState<boolean>(false);

  const toggleNode = (nodeId: string) => {
    setExpandedNodes((prev) => {
      const next = new Set(prev);
      if (next.has(nodeId)) {
        next.delete(nodeId);
      } else {
        next.add(nodeId);
      }
      return next;
    });
  };

  const renderTocNode = (node: any, index: number, flatIndex?: number) => {
    const isExpanded = expandedNodes.has(node.navId || `node-${index}`);
    const hasChildren = node.children && node.children.length > 0;

    const totalChapters = flatToc.length;
    const readCount = Math.floor((totalChapters * progress) / 100);
    const currentFlatIndex =
      flatIndex !== undefined
        ? flatIndex
        : flatToc.findIndex((n: any) => n.navId === node.navId);
    const isRead = currentFlatIndex !== -1 && currentFlatIndex < readCount;

    return (
      <li key={node.navId || index} className="toc-node">
        <div
          className={`node ${isRead ? "read" : "unread"}`}
          onClick={() => hasChildren && toggleNode(node.navId || `node-${index}`)}
          style={{ cursor: hasChildren ? "pointer" : "default" }}
        >
          {hasChildren ? (
            <span className="node-toggle">{isExpanded ? "-" : "+"}</span>
          ) : (
            <span className="node-bullet">•</span>
          )}
          <div
            className="node-label"
            onClick={(e) => {
              if (!hasChildren) {
                e.stopPropagation();
                navigate(`/reader/kalyanakalpataru/` + kalpatrauDetail?.slug, {
                  state: {
                    kalpatrauDetailId: kalpatrauDetail?.id,
                    bookName: kalpatrauDetail?.name,
                    slug: kalpatrauDetail?.slug,
                    location:
                      node.srcFile + (node.srcAnchor ? `#${node.srcAnchor}` : "") ||
                      node.href,
                    tocNode: node,
                    type: BookContentType.kalpatru,
                  },
                });
              }
            }}
            style={{ cursor: "pointer" }}
          >
             <h3 style={{fontSize:"22px",fontWeight:400,fontFamily:"ChanakyaUni, NalandaTim, Tunga"}}> {node.label || node.title}</h3> 
          </div>
        </div>
        {hasChildren && (
          <ul className={`children ${isExpanded ? "expanded" : ""}`}>
            {node.children.map((child: any, cIdx: number) => {
              const childFlatIndex = flatToc.findIndex((n: any) => n.navId === child.navId);
              return renderTocNode(child, `${index}-${cIdx}` as any, childFlatIndex);
            })}
          </ul>
        )}
      </li>
    );
  };

  const hasToc = toc.length > 0;
  const hasRelateds = useMemo(() => !!(relateds && relateds.length > 0), [relateds]);

  const indicatorTranslate = useMemo(() => {
    const tabs = [];
    if (hasRelateds) tabs.push('related');
    if (hasToc) tabs.push('toc');

    const tabIndex = tabs.indexOf(activeTab);
    return `${tabIndex * 160}px`;
  }, [hasRelateds, hasToc, activeTab]);

  const handleLoginStateChange = (newState: any) => {
    setLoginState(newState === true);
    navigate(`/reader/kalyanakalpataru/` + kalpatrauDetail.slug, {
      state: {
        kalpatrauDetailId: kalpatruId,
        bookName: state?.bookName,
        slug: state?.kalpatruSlug,
        type: BookContentType.kalpatru,
      },
    });
  };

  const notify = () => {
    if (UserIdentity) {
      showNotification(!isLiked
        ?
        localStorage.getItem("lan") === "hindi"
          ? "पत्रिका को सफलतापूर्वक मेरी पसंद में जोड़ा गया है।"
          : "Magazine has been successfully added to the favourites"
        : localStorage.getItem("lan") === "hindi"
          ? "पत्रिका मेरी पसंद से हटा दी गई है।"
          : "Magazine has been removed from favourites"
      )
    }
  };

  const toggleLike = () => {
    !isLiked
      ? KalpataruServices.addKalpatruFavourite(kalpatruId).then((res) => {
        res.status && setIsLiked(true);
      })
      : KalpataruServices.removeKalpatruFavourite(kalpatruId).then((res) => {
        res.status && setIsLiked(false);
      });
    setToggleFav((x) => !x);
  };

  const monthName = getMonthNameFromNumber(kalpatrauDetail?.months);

  useEffect(() => {
    if (location.state) {
      setKalpatruId(state?.kalpatruId);
    }
  }, [location]);

  useEffect(() => {
    if (kalpatruId) {
      setRefresh(false);
      const fetchData = async () => {
        try {
          // Reuse prefetched detail if navigation provided it
          const prefetched = kalpatrauDetail;

          const [resResp, navRes] = await Promise.all([
            prefetched ? Promise.resolve({ status: true, result: prefetched }) : KalpataruServices.getKalpataruDetail(kalpatruId),
            KalpataruServices.getNavigationDetails(kalpatruId),
          ]);

          if (prefetched) {
            console.log("KalpataruDetailPage: using pre-fetched kalpatruDetail from navigation state, skipping API call.");
          }

          if (resResp?.status) {
            setKalpatrauDetail(resResp.result);
            setIsLiked(resResp?.result?.isFavourite);
            // console.log(resResp,"asdfawewerwerwerwe")
            // Set description for SEO and description tab
            setDescription({ __html: resResp.result?.description || "" });
          }

          if (navRes?.status) {
            const navigationTree = navRes.result?.navigationTree || [];
            setToc(navigationTree);

            if (navRes.result?.lastPosition) {
              setLastPos(navRes.result.lastPosition);
            }

            const rawFont = navRes.result?.bookFontSize;
            const parsedFont = parseFloat(rawFont);
            setLastFontSize(
              rawFont !== null &&
                rawFont !== undefined &&
                rawFont !== "" &&
                rawFont !== "null" &&
                !isNaN(parsedFont)
                ? parsedFont
                : 100
            );

            if (navRes.result?.navOrder) {
              const totalChapters = navigationTree.length;
              setProgress(totalChapters > 0 ? (navRes.result.navOrder / totalChapters) * 100 : 0);
            } else {
              setProgress(0);
            }
            setNavOrder(navRes.result?.navOrder || 0);
          }
        } catch (error) {
          console.error("Error fetching data:", error);
        } finally {
          setLoading(false);
        }
      }
      fetchData();
    }
  }, [refresh, i18n.language, kalpatruId]);

  useEffect(() => {
    setRefresh(false);
    if (kalpatruId) {
      KalpataruServices.getRelatedKalpatrau(kalpatruId).then((res) => {
        if (res?.status) {
          setRelatedKalpatrau(res.result);
        }
      });
    }
  }, [refresh, i18n.language, kalpatruId]);

  useEffect(() => {
    if (kalpatruId) {
      EpubServices.getbookmark(
        "kalyankalpatarubookmarks",
        kalpatruId
      ).then((res: any) => {
        if (res.status) {
          setBookMarkData(res?.result)
        }
      });
    }
  }, [refresh, i18n.language, userId]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (!hasRelateds && activeTab === 'related') {
      if (hasToc) setActiveTab('toc');
    }
  }, [hasRelateds, activeTab, hasToc]);

  useEffect(() => {
    if (!hasToc && activeTab === 'toc') {
      setActiveTab('related');
    }
  }, [hasToc, activeTab, hasRelateds]);

  return (
    <>
      {kalpatrauDetail?.slug ? (
        <>

          <KalyankalpataruSeo
            kalyanakalpataru={kalpatrauDetail}
            canonicalPath={`/magazines/kalyanakalpataru/${kalpatrauDetail?.slug}`}
          />
        </>
      ) : null}


      <div
        className="newcontainer"
        style={{
          backgroundColor: "#FFF6E1",
          padding: "1px 0px 4% 0",
          marginTop: 0,
        }}
      >
        <Breadcrumbs
          mainsubBreadCrumb={t("Kalpataru_tr")}
          subBreadCrumb={t("Home_tr")}
          navigatemainsubBreadCrumb={() => {
            navigate(`/`);
          }}
          subBreadCrumbTwo={t("magazine_tr")}
          navigatesubBreadCrumb={() => {
            navigate(`/magazines`);
          }}
          subBreadCrumbThree={t("Kalpataru_tr")}
          navigatethreeBreadCrumb={() => {
            navigate(`/magazines/kalyanakalpataru`);
          }}
          subBreadCrumbFour={kalpatrauDetail?.name}
        />
        <div className="container">
          <div className="row">
            <div>
              {kalpatrauDetail ? (
                <div
                  className="containers card-gst"
                  style={{
                    width: "100%",
                    marginTop: "25px",
                    backgroundColor: "#FFFAF0",
                    boxShadow: "0px 0px 10px 0px #dcd1b8",
                  }}
                >
                  <div className="mat-card row" key={`book-${kalpatrauDetail.id}`}>
                    <div style={{ padding: "0px 0px 0 0px", margin: "0 0 0 0" }}>
                      <div className="single-product col-lg-3">
                        <div
                          style={{
                            border: "1px solid #eadfc8",
                            padding: "30px",
                            background: "#fff",
                            borderRadius: "5px",
                            textAlign: "center",
                            width: "125%",
                          }}
                        >
                          <img
                            src={kalpatrauDetail.kalyanKalpataruThumbPath}
                            onError={(e) => {
                              e.currentTarget.src = DefaultBook;
                            }}
                            onClick={() => setShowCoverPopup(true)}
                            alt={kalpatrauDetail.name}
                            title={kalpatrauDetail.name}
                            className="bkdetailimg"
                            style={{ cursor: "pointer" }}
                            width="256"
                            height="365"
                          />
                        </div>
                      </div>

                      <div className="single-product-author col-lg-8">
                        <div className="single-book-heading">
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <h1
                              style={{
                                fontFamily: "ChanakyaUni",
                                fontSize: "40px",
                                color: "#472d1e",
                                marginTop: "7px",
                              }}
                            >
                              {kalpatrauDetail.name}
                            </h1>
                            <label
                              onClick={() => {
                                if (!userId) setLogIn(true);
                              }}
                              style={{ display: "flex", margin: 0 }}
                            >
                              <label style={{ display: bookMarkData?.length > 0 ? "block" : "none", marginRight: "10px" }}>
                                <div className="bkmarkicon"
                                  onClick={() => {
                                    setBookMark(bookMark === true ? false : true)
                                  }}>
                                  <div>
                                    <img src={bookmarkIcon} style={{ width: "45px", height: "45px" }} alt="bookmaarkicon" />
                                  </div>
                                  <div>
                                    {bookMark && userId && (
                                      <div className="bkmarkicon-style">
                                        <div style={{
                                          display: "flex",
                                          backgroundColor: "#ff6427"
                                        }}>
                                          <p
                                            style={{
                                              color: "#fff",
                                              fontStyle: "normal",
                                              lineHeight: "normal",
                                              borderBottom: "none",
                                              padding: "0 0 0 10%",
                                              margin: 0,
                                            }}>{t("bk_mark_tr")}</p>
                                          <img src={closeicon} style={{ width: "20px", height: "20px", margin: "4px 0 0 10px", cursor: "pointer" }} onClick={() => setBookMark(false)} alt="" />
                                        </div>
                                        <ol style={{ paddingLeft: "20px", fontSize: "20px" }}>
                                          {bookMarkData && bookMarkData?.map((item: any, index: number) => (
                                            <li onClick={() => {
                                              navigate(`/reader/kalyanakalpataru/` + kalpatrauDetail.slug, {
                                                state: {
                                                  kalpatrauDetailId: kalpatrauDetail.id,
                                                  bookName: kalpatrauDetail.name,
                                                  chapterName: item?.name,
                                                  slug: kalpatrauDetail.slug,
                                                  location: item?.cfi,
                                                  type: BookContentType.kalpatru,
                                                },
                                              });
                                            }}>
                                              <p style={{ borderBottom: "none", padding: 0, margin: "0 0 0 5px", color: "#000", cursor: "pointer" }}>{item?.name}</p></li>
                                          ))}
                                        </ol>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </label>

                              <label
                                onClick={() => {
                                  toggleLike();
                                  notify();
                                }}
                              >
                                <img
                                  src={isLiked ? Favfill : Favempty}
                                  alt="Favicon"
                                  style={{ width: "45px", cursor: "pointer" }}
                                />
                              </label>
                            </label>
                          </div>
                        </div>
                        {kalpatrauDetail.author ? (
                          <div>
                            <p>
                              <label>{t("Authors_tr")} </label>
                              {kalpatrauDetail.author}
                            </p>
                          </div>
                        ) : (
                          ""
                        )}
                        {kalpatrauDetail.kalyanKalpataruLanguage ? (
                          <div>
                            <p>
                              {/* <label>{t("Language_tr")} </label>
                              <h2
                                style={{
                                  display: "inline",
                                  marginRight: "85px",
                                  fontSize: "23px",
                                  color: '#ff731f'
                                }}
                              >
                                {kalpatrauDetail.kalyanKalpataruLanguage}
                              </h2> */}

                             <h2
                              style={{
                                display: "inline",
                                marginRight: "85px",
                                fontSize: "23px",
                                color: 'black'
                              }}
                            >
                              {t("Language_tr")}
                            </h2>
                                <h2
                              style={{
                                display: "inline",
                                marginRight: "85px",
                                fontSize: "23px",
                                color: '#ff731f'
                              }}
                            >
                                 {kalpatrauDetail.kalyanKalpataruLanguage}
                            </h2>

                            </p>
                          </div>
                        ) : (
                          ""
                        )}
                        <div className="bookdecription">
                          <div className="yearmonth" style={{ display: "flex", justifyContent: "center", border: "1px solid #ffaf68", paddingTop: "15px", borderTopLeftRadius: "5px", borderBottomLeftRadius: "5px" }}>
                            <label style={{ color: "#472d1e", fontSize: "23px", fontFamily: "ChanakyaUni", flex: 1, textAlign: "center", paddingBottom: 0 }}>{t("Year_tr")}</label>
                            <label style={{ fontSize: "23px", color: "#ff731f", flex: 1, textAlign: "center" }}>{kalpatrauDetail?.years}</label>
                          </div>
                          <div className="yearmonth" style={{ display: "flex", justifyContent: "center", border: "1px solid #ffaf68", paddingTop: "15px", borderLeft: 0, borderRight: 0 }}>
                            <label style={{ color: "#472d1e", fontSize: "23px", fontFamily: "ChanakyaUni", flex: 1, textAlign: "center" }}>{t("Month_tr")}</label>
                            <label style={{ fontSize: "23px", color: "#ff731f", flex: 1, textAlign: "center" }}>{monthName}</label>
                          </div>
                          <div className="yearmonth" style={{ display: "flex", justifyContent: "center", border: "1px solid #ffaf68", paddingTop: "15px", borderTopRightRadius: "5px", borderBottomRightRadius: "5px" }}>
                            <label style={{ color: "#472d1e", fontSize: "23px", fontFamily: "ChanakyaUni", flex: 1, textAlign: "center" }}>{t("Number_tr")}</label>
                            <label style={{ fontSize: "23px", color: "#ff731f", flex: 1, textAlign: "center" }}>{kalpatrauDetail?.editionNo}</label>
                          </div>
                        </div>
                        <div ref={notificationRef} style={{ color: "#ff3d28", fontSize: '20px', marginBottom: "10px" }} className="notification-bar"></div>
                        <div className="actions">
                          {navOrder > 0 && (
                            <div className="book-progress">
                              <div className="book-progress__label">{Math.round(progress)} %</div>
                              <div className="book-progress__track">
                                <div className="book-progress__value" style={{ width: `${progress}%` }}></div>
                              </div>
                            </div>
                          )}
                          <div className="buttons">
                            {navOrder === 0 ? (
                              <button
                                className="btn-book-action"
                                onClick={() => {
                                  if (UserIdentity) {
                                    navigate(`/reader/kalyanakalpataru/` + kalpatrauDetail.slug, {
                                      state: {
                                        kalpatrauDetailId: kalpatrauDetail.id,
                                        bookName: kalpatrauDetail.name,
                                        slug: kalpatrauDetail.slug,
                                        type: BookContentType.kalpatru,
                                      },
                                    });
                                  } else {
                                    setLogIn(true);
                                  }
                                }}
                              >
                                {t("read_magazine_tr")}
                              </button>
                            ) : (
                              <>
                                <button
                                  className="btn-book-action"
                                  onClick={() => {
                                    if (UserIdentity) {
                                      navigate(`/reader/kalyanakalpataru/` + kalpatrauDetail.slug, {
                                        state: {
                                          kalpatrauDetailId: kalpatrauDetail.id,
                                          bookName: kalpatrauDetail.name,
                                          slug: kalpatrauDetail.slug,
                                          type: BookContentType.kalpatru,
                                        },
                                      });
                                    } else {
                                      setLogIn(true);
                                    }
                                  }}
                                >
                                  {t("Read_From_Start_tr")}
                                </button>
                                <button
                                  className="btn-book-action"
                                  onClick={() => {
                                    navigate(`/reader/kalyanakalpataru/` + kalpatrauDetail.slug, {
                                      state: {
                                        kalpatrauDetailId: kalpatrauDetail.id,
                                        bookName: kalpatrauDetail.name,
                                        slug: kalpatrauDetail.slug,
                                        location: lastPos,
                                        type: BookContentType.kalpatru,
                                        fontsize: lastFontSize,
                                      },
                                    });
                                  }}
                                >
                                  {t("Continue_Reading_tr")}
                                </button>
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div style={{ margin: "0 05px 5% 05px" }}>
                    <div className="tabs-container">
                      <div className="tabs-line">
                        <div className="tabs" role="tablist">
                          {hasRelateds && (
                            <button
                              className="tabLarge"
                              aria-selected={activeTab === 'related'}
                              onClick={() => setActiveTab('related')}
                            >
                              <h2 style={{fontSize:"18px",fontWeight:600}}>{t("Related_Kalyan_Kalpataru_tr")}</h2>
                            </button>
                          )}
                          {hasToc && (
                            <button
                              className="tab"
                              aria-selected={activeTab === "toc"}
                              onClick={() => setActiveTab("toc")}
                            >
                              
                               <h2 style={{fontSize:"18px",fontWeight:600}}>{t("Table_of_Contents_tr")}</h2>
                            </button>
                          )}
                        </div>
                        <div
                          className="tab-indicator"
                          style={{
                            transform: `translateX(${indicatorTranslate})`,
                            width: "160px",
                          }}
                        ></div>
                      </div>

                      <div className="tab-panels">
                        {hasRelateds && activeTab === 'related' && (
                          <div className="panel active">
                            <div style={{ margin: "20px" }}>
                              <div className="clsslide row">
                                <div>
                                  <div style={{ paddingBottom: "20px", width: "97%", position: "relative", left: "18px" }}>
                                    <Slider {...settings} infinite={relateds && relateds.length > 5}>
                                      {relateds && relateds.map((related: any) => (
                                        <div
                                          className="slider-books sidebarmargin"
                                          key={`related-${related.id}`}
                                          onClick={() => {
                                            navigate(`/magazines/kalyanakalpataru/${related.slug}`, {
                                              state: {
                                                kalpatruId: related.id,
                                                kalpatruSlug: related.slug
                                              }
                                            });
                                          }}
                                        >
                                          <div>
                                            <img
                                              src={related.kalyanKalpataruThumbPath || DefaultBook}
                                              onError={(e: any) => e.currentTarget.src = DefaultBook}
                                              className="imgcenter"
                                              style={{ cursor: "pointer", borderRadius: 0 }}
                                              alt={related.name}
                                              title={related.name}
                                              width="150"
                                              height="212"
                                            />
                                            {/* <h3 style={{ fontFamily: "ChanakyaUni" ,fontWeight:700,fontSize:"18px"}}>{related.name}</h3> */}
                                                <h3 style={{ fontFamily: "ChanakyaUni" ,fontSize:"18px",paddingTop:12}}>{related.name}</h3>
                                          </div>
                                        </div>
                                      ))}
                                    </Slider>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}

                        {hasToc && (
                          <div className={`panel ${activeTab === "toc" ? "active" : ""}`}>
                            <ul className="toc">
                              {navigationTree.map((node: any, idx: number) => renderTocNode(node, idx))}
                            </ul>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="ebooks-category resultnotfound">
                  {loading && <Loader loading={loading} />}
                  {t("result_not_found_tr")}
                </div>
              )}
            </div>
          </div>
          <LogInModel opens={logIn} onCloses={closeModal} onLoginStateChange={handleLoginStateChange} />
          {kalpatrauDetail && (
            <BookCoverPopup
              show={showCoverPopup}
              onClose={() => setShowCoverPopup(false)}
              imagePath={kalpatrauDetail.kalyanKalpataruThumbPath}
              bookName={kalpatrauDetail.name}
            />
          )}
        </div>
      </div>

    </>
  );
};
export default KalpataruDetailPage;
